import { LeftSidebarView, ViewBody } from 'components/Sidebar'
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { ModalBoardContext } from 'components/Modal'
import { useBoardContext } from 'dataProviders/Board'
import {
  ListGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import {
  ListItem
} from 'components/List'
import SelectedDocumentTemplates from '../SelectedDocumentTemplates'
import { useDispatch, useSelector } from 'react-redux'
import requestChangeDocumentFolderPath from '../sagas/requestChangeDocumentFolderPath'
import requestChangeDocumentFolderSettings from '../sagas/requestChangeDocumentFolderSettings'
import { useCardContext } from 'dataProviders/Card'
import styled from 'styled-components'
import DocumentItem from 'routes/Board/DocumentList/DocumentItem'
import Documents from 'routes/Board/DocumentList/Documents'
import Button from 'components/Button'
import SelectedDocumentFolder from '../SelectedDocumentFolder'

const SelectButton = styled(Button)`
  float: right;
`

const SHOW_MAX_OPTIONS = [5, 10, 15, 20]

const DocumentFolderSettings: React.FC<LeftSidebarProps & {
  elementId: number;
}> = ({
  leftSidebar,
  elementId,
}) => {
   const dispatch = useDispatch()

  const boardContext = useBoardContext()

  const cardContext = useCardContext()

  const name = useSelector<any, string>(state => state['view-card'].elements.elementsById[elementId]?.name)

  const documentSourceId = useSelector<any, string>(state => state['view-card'].elements.elementsById[elementId]?.documentSourceId)

  const path = useSelector<any, string>(state => state['view-card'].elements.elementsById[elementId]?.path)

  const settings = useSelector<any, any>(state => state['view-card'].elements.elementsById[elementId]?.settings)

  const handleShowMaxItemsChange = useCallback(event => {
    dispatch(requestChangeDocumentFolderSettings({
      cardId: cardContext.id,
      documentFolderId: elementId,
      settings: {
        ShowMaxItems: Number(event.target.value)
      }
    }))
  }, [elementId, cardContext.id])

  const handleSelectedFolderClick = useCallback(() => {
    leftSidebar.push(() =>
      <ModalBoardContext boardId={boardContext.id}>
        <LeftSidebarView
          title={<FormattedMessage id='DOCUMENT_FOLDER_SELECT_SOURCE' />}
          subtitle={name}
        >
          <Documents
            boardId={boardContext.id}
            documentComponent={(props) =>
              <DocumentItem
                {...props}
                name={
                  (
                    props.type === 'source' ||
                    props.type === 'folder'
                  ) ? (
                    <>
                      {props.name}
                      <SelectButton
                        bsSize='xsmall'
                        bsStyle='primary'
                        onClick={(event) => {
                          event.stopPropagation()

                          leftSidebar.pop()

                          dispatch(requestChangeDocumentFolderPath({
                            cardId: cardContext.id,
                            documentFolderId: elementId,
                            documentSourceId: props.documentSourceId,
                            path: props.type === 'folder' ? props.url : undefined,
                          }))
                        }}
                      >
                        <FormattedMessage id='DOCUMENT_FOLDER_SELECT_SOURCE_SELECT' />
                      </SelectButton>
                    </>
                    ) : props.name
                }
              />
            }
          />
        </LeftSidebarView>
      </ModalBoardContext>
    )
  }, [elementId, boardContext.id, cardContext.id])

  const handleSelectedDocumentTemplatesClick = useCallback(() => {
    leftSidebar.pop()

    leftSidebar.push(() =>
      <ModalBoardContext boardId={boardContext.id}>
        <SelectedDocumentTemplates documentListId={elementId} />
      </ModalBoardContext>
    )
  }, [elementId, boardContext.id])

  return (
    <LeftSidebarView
      title={<FormattedMessage id='SETTINGS' />}
      subtitle={name}
    >
      <ViewBody>
        <FormGroup>
          <ControlLabel><FormattedMessage id='DOCUMENT_FOLDER_SELECTED_SOURCE' /></ControlLabel>
          <SelectedDocumentFolder
            documentSourceId={documentSourceId}
            path={path}
            onClick={handleSelectedFolderClick}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel><FormattedMessage id='DOCUMENT_FOLDER_SETTINGS_SHOW_MAX_ITEMS' /></ControlLabel>
          <FormControl
            value={settings?.ShowMaxItems}
            onChange={handleShowMaxItemsChange}
            componentClass='select'
          >
            {SHOW_MAX_OPTIONS.map(value =>
              <option
                key={value}
                value={value}
              >
                {value}
              </option>
            )}
          </FormControl>
        </FormGroup>
      </ViewBody>
      <ListGroup>
        <ListItem
          borderedIcon
          icon={<KanBoIcon fixedWidth name='kanbo-16-document-template-source' />}
          onClick={handleSelectedDocumentTemplatesClick}
        >
          <FormattedMessage id='DOCUMENT_LIST_SETTINGS_ALLOWED_DOCUMENT_TEMPLATES' />
        </ListItem>
      </ListGroup>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(DocumentFolderSettings)
